export const DOWNLOAD_EXCEL = 'download/DOWNLOAD_EXCEL';
export const SET_SPIN = 'spin/SET_SPIN';
